import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE,
} from '@app/components/base/content-structure/cards-grid-config';
import { CompositionCardSkeleton } from '../composition-card/CompositionCardSkeleton';

const SKELETON_CARD_COUNT = 6;

/**
 * Loading skeleton for the compositions grid (matches card grid layout).
 */
export function CompositionsGridSkeleton() {
  return (
    <CardsGrid columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {Array.from({ length: SKELETON_CARD_COUNT }).map((_, i) => (
        <CardsGridItem size={CARDS_GRID_ITEM_SIZE} key={i}>
          <CompositionCardSkeleton />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
